import AWS from 'aws-sdk';
import { Auth, Logger, API } from 'aws-amplify';

import store from '@/store';

// Configuración de valores del ambiente.
// Este archivo NO debe estar ignorado en el repositorio.
import * as EnvVarsUtils from '@/library/utils/env-vars';

window.test = Auth.signOut();

// Ejemplo de uso:
// import * as config from '@/config';
// console.log(config.URL_API_BOLETAS);

// URL_API_BOLETAS: url de la api de boletas
export const URL_API_BOLETAS = EnvVarsUtils.getEnvVar('URL_API_BOLETAS');
export const URL_API_HORA = EnvVarsUtils.getEnvVar('URL_API_HORA');

const IdentityPoolId = EnvVarsUtils.getEnvVar('IdentityPoolId');


/////////////////////////////////////
// TODO por remover /////////////////
export const USUARIOS_NOTIFICADORES = EnvVarsUtils.getEnvVar('USUARIOS_NOTIFICADORES');
/////////////////////////////////////


const refreshLogger = new Logger('RefreshHandler', 'DEBUG');

// Formateo números
let numberFormatter = function(x) {
	if(typeof x !== 'number' || !isFinite(x)) {
		throw 'Número a formatear no es número o no es finito';
	}
	let stringifiedNumber = `${x}`;
	let isNegative = (stringifiedNumber[0] === '-');
	let stringifiedNumberWithoutSign = isNegative ? stringifiedNumber.substr(1) : stringifiedNumber;
	let parts = stringifiedNumberWithoutSign.split('.');
	let intPart = parts[0];
	let decPart = parts[1];
	let intPartLength = intPart.length;
	let reversedIntPart = intPart.split('').reverse().join('');
	let reversedNewIntPart = '';
	for(let i=0; i<intPartLength; i++) {
		if((i%3===0) && (i>0)) {
			reversedNewIntPart = reversedNewIntPart + '.';
		}
		reversedNewIntPart = reversedNewIntPart + reversedIntPart[i];
	}
	let newIntPart = reversedNewIntPart.split('').reverse().join('');
	return `${isNegative ? '-' : ''}${newIntPart}` + (decPart === undefined ? '' : `,${decPart}`);
};
let moneyFormatter = function(x) {
	return `$ ${numberFormatter(x)}`;
};

export const FORMATTERS = {
	NUMBER: numberFormatter,
	MONEY: moneyFormatter,
};

export const refreshHandler = function(err){
	

	// window.LOG_LEVEL = 'DEBUG';

	store.dispatch('usuario/getCurrentUser')
		.then(user=>{
			let identityId = user.identityId;
			let username = user.username;
			let identityToken = user.token;

			// store.dispatch('usuario/generateCredentials', identityToken, identityId, username)

			store.dispatch('usuario/getAWSCredentials')
				.then(credentials=>{

					refreshLogger.debug('credentials', credentials);
					let expireIn=credentials.expireTime;

					return new Promise((res, rej) => {
						const data = {
							token: identityToken, // the token from the provider
							expires_at: expireIn, // the timestamp for the expiration
							identity_id: identityId, // optional, the identityId for the credentials
						}
						refreshLogger.debug( 'promise', data )
						res(data);
					})
				})	
				.catch(err=>{
					refreshLogger.debug(err);
				})
			
		})
		.catch(err=>{
			refreshLogger.debug( 'getAWS', err )
		});

	// try{
	// 	Auth.currentAuthenticatedUser()
	// 		.then( user=>{

	// 			let params = {
	// 				body:{
	// 					user: user.username,
	// 					identityId: user.identityId,
	// 				}
	// 			};

	// 			console.log( 'expires_at',user.expires_at )

	// 			// let call = API.post('apiAuthSII', '/refresh-token', params);

	// 			// console.log('call', call);

	// 			// return call;

	// 			return new Promise((res, rej) => {
	// 				API.post('apiAuthSII', '/refresh-token', params)
	// 					.then(response=>{
	// 						console.log('pre-promise', new Date( response.expires_at ) )
	// 						const data = {
	// 							token: response.token, // the token from the provider
	// 							expires_at: response.expires_at, // the timestamp for the expiration
	// 							identity_id: response.identity_id, // optional, the identityId for the credentials
	// 						}
	// 						console.log( 'promise', new Date( response.expires_at ) )
	// 						return data;
	// 				})
	// 				.catch(err=>{
	// 					refreshLogger.debug(err);
	// 					throw err;
	// 				});
	// 			})
	// 		// })
	// 		// .catch(err=>{
	// 		// 	console.log('handler err', err)
	// 		// 	throw err;
	// 		// })
	// }catch(err){
	// 	refreshLogger.debug(err);
	// }

	console.log('paso y paso')
}

export const refreshHandlerAsync = async function(err){

	let identityId;
	let username;

	// window.LOG_LEVEL = 'DEBUG';

	try{
		let user = await store.dispatch('usuario/getCurrentUser');

		let params = {
			body:{
				user: user.username,
				identityId: user.identityId,
			}
		};

		refreshLogger.debug( 'expires_at',(user.expires_at - new Date().getTime())/1000 )

		return new Promise((res,rej)=>{

			API.post('apiAuthSII', '/refresh-token', params)
				.then(response=>{
					refreshLogger.debug('call', response);
					res( new Promise((resolve,reject)=>{
						refreshLogger.debug('pre-promise', response);

						const data = {
							token: response.token, // the token from the provider
							expires_at: response.expires_at, // the timestamp for the expiration
							identity_id: response.identity_id, // optional, the identityId for the credentials
						};
						refreshLogger.debug( 'promise', response, data );
						resolve(data);

					})
					)
				})
		});

	}catch(err){
		refreshLogger.debug(err)
	}
}

export const refreshHandlerAwait = async function(err){
	
	let user = await store.dispatch('usuario/getCurrentUser')
	let identityId = user.identityId;
	let username = user.username;
	let identityToken = user.token;

	AWS.config.update({
					region: 'us-east-1'
				});

	let credentials = new AWS.CognitoIdentityCredentials({
		IdentityPoolId: IdentityPoolId,
		IdentityId: identityId,
		LoginId: username,
		Logins: {
			'cognito-identity.amazonaws.com': identityToken
		}
	});

	AWS.config.credentials = credentials;

	let expires_at = new Date().getTime()+(1*60*60*1000);

	return new Promise((res, rej) => {
		const data = {
			token: identityToken, // the token from the provider
			expires_at: expires_at, // the timestamp for the expiration
			identity_id: identityId, // optional, the identityId for the credentials
		}
		refreshLogger.debug( 'promise', data )
		AWS.config.credentials.refresh((err)=> {
			if(err)  {
				// console.log(err);
			}else{
				// console.log("TOKEN SUCCESSFULLY UPDATED");
			}
		});
		res(data);
	})

	console.log('paso y paso')
}